import { render } from "./acheive-goals.vue?vue&type=template&id=0f278b4a"
import script from "./acheive-goals.vue?vue&type=script&lang=js"
export * from "./acheive-goals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__